function initPreorderCheckoutGuard() {

  // Locate preorder confirmation block
  const wrap = document.querySelector('.preorder-confirm');
  if (!wrap) return;

  // Locate checkbox and checkout button
  const checkbox = document.getElementById('PreorderConfirm');
  const checkoutBtn = document.querySelector('[data-preorder-checkout]');
  if (!checkbox || !checkoutBtn) return;

  // Enable or disable checkout button depending on checkbox state
  const updateCheckoutState = () => {
    checkoutBtn.disabled = !checkbox.checked;
  };

  // Initial state
  updateCheckoutState();

  // Update state when checkbox changes
  checkbox.addEventListener('change', updateCheckoutState);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initPreorderCheckoutGuard);

// Re-initialize when cart updates dynamically
const preorderObserver = new MutationObserver(() => {
  initPreorderCheckoutGuard();
});

preorderObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});